module.exports = __webpack_public_path__ + "static/img/17057B_3_R_20190716_fit.36236ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17057B_3_R_20190716_fit.png
// module id = y3b9
// module chunks = 0